/** @format */

// import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const ServiceCartPagePropTypes = exact({});

export default ServiceCartPagePropTypes;
